import React from "react";
import { useTranslation } from "react-i18next";
import { View } from "tamagui";
import { ImageFit } from "../../../ui/ImageFit";
import type { BusinessFeedItem } from "../BusinessFeedItem";
import { FeedItemAuthorUI } from "../ui/FeedItemAuthor";
import { FeedTextInput } from "../ui/FeedTextInput";
import { FeedTextWithMentions } from "../ui/FeedTextWithMentions";

export type FeedItemTextData = {
  authorUid: string;
  text: string;
  mediaUrl: string | null;
};

export const FeedItemTextUI = ({
  item,
  isEditMode,
  onEdit,
}: {
  item: BusinessFeedItem;
  isEditMode: boolean;
  onEdit: () => void;
}) => {
  const itemData = item.data.itemData as FeedItemTextData;

  const author = item.maybeAuthor;
  const { t } = useTranslation();
  if (!author) return null;

  const hasTextContent = itemData.text || isEditMode;

  return (
    <>
      <FeedItemAuthorUI
        businessUid={item.businessPlan.uid}
        feedItem={item}
        author={author}
        dateTs={item.data.ts}
      />

      <View>
        {itemData.mediaUrl && (
          <View>
            <ImageFit assetUrl={itemData.mediaUrl} />
          </View>
        )}
        {hasTextContent && (
          <View
            paddingVertical={"$large"}
            paddingHorizontal={"$space.larger"}
            gap={"$medium"}
          >
            {!isEditMode && (
              <FeedTextWithMentions
                text={itemData.text}
                mentions={item.data.mentions}
                businessPlan={item.businessPlan}
              />
            )}

            {isEditMode && (
              <FeedTextInput
                autoFocus
                businessPlan={item.businessPlan}
                placeholder={t("business:feed_edit_item")}
                placeholderFocused={t("business:feed_mention_tip")}
                defaultValue={itemData.text}
                submitOnEnter
                onSubmitEditing={async (e) => {
                  await item.edit(e.nativeEvent.text);
                  onEdit();
                }}
              />
            )}
          </View>
        )}
      </View>
    </>
  );
};
